export default __webpack_public_path__ + "static/media/banner_wtmec_sitio.f0d61988.jpg";